import File from "@/scripts/models/file.model";
import Company from "@/scripts/models/company.model";
import CampaignPaymentMethodProvider from "@/scripts/models/campaignPaymentMethodProvider.model";

export default class Campaign {

    constructor() {

        this.id = 0;
        this.name = "";
        this.campaignTypeId = 0;
        // Permite ao voluntario se inscrever mais de uma vez na mesma campanha. Faltava
        // aqui: em campanha nova o radio do Passo de edicao ficava sem propriedade para
        // escrever, e o Vue 2 nao reage a propriedade criada depois -- a selecao nao
        // aparecia marcada. Em campanha existente o valor vinha no payload da API e
        // funcionava, o que escondia o problema.
        this.subscribeMoreThanOneTime = false;
        // Modo do sorteio: 1 = por valor doado (default, comportamento de sempre),
        // 2 = por faixa (a quantidade vem do produto de doacao). Declarado aqui pelo
        // mesmo motivo do subscribeMoreThanOneTime acima: em campanha nova o seletor
        // ficaria sem propriedade para escrever e o Vue 2 nao reage a propriedade
        // criada depois.
        this.drawModeId = 1;
        // Texto HTML proprio da modal LGPD (vazio = texto da empresa).
        this.lgpdText = "";
        this.lgpdAcceptText = "";
        this.lgpdDeclineText = "";
        this.lgpdSkipConfirmation = false;
        this.minimumDonationValue = 0;
        this.objetiveDonationValue = 0;
        this.isPublic = true;
        this.paymentMethodList = [];
        this.donationRecurrencePeriodList = {};
        this.projectList = [];
        this.initialDate = null;
        this.finalDate = null;
        this.subdomain = "";
        this.totalValue = 0;
        this.capturedValue = 0;
        this.file = new File();
        this.faviconFile = new File();
        this.company = new Company();
        this.published = false;
        this.campaignPhaseId = 0;
        this.campaignNewsList = [];
        this.directBeneficiaries = 0;
        this.indirectBeneficiaries = 0;
        this.hasEmployees = false;
        this.taxOwner = 1;
        this.campaignCompanyPaymentMethodList = [];
        this.ticketConfigId = null;
        this.googleAnalyticsId = "";
        this.googleTagManager = "";
        this.facebookPixelId = "";
        this.metaTitle = "";
        this.metaDescription = "";
        this.chatbotType = 1;
        this.chatbotId = 0;
        this.capturedDonationValue = 0;
        this.cpfIsRequired = true;
        this.withRecaptcha = false;
        this.loginAttempts = 0;
        this.allowAnnonymousDonation = false;
        this.informCompany = false;
        this.informDepartament = false;
        this.informAddress = true;
        this.informState = true;
        this.consentTermDefault = true;
        this.modalConfirmationOnDonationActive = false;
        this.campaignPaymentMethodProvider = new CampaignPaymentMethodProvider();
        this.campaignConsentTerms = [];
        this.campaignInputInformation = {};
        this.allowUsdDonation = true;
        this.receiver = 1;
        this.allowUsdDonation = true;       
        this.receiverParcelament = null;
        this.creditCardParcelament = 0;
        this.minimumParcelamentValue = 0;
        this.permitCnpjDonation = false;
        this.simulatorPercentage=6;
        this.salesForceIntegrationId = null;
        this.checkoutSimplifiedOpenValue = false;
        this.taxAUC = 0;
        this.contractualFee= 0;
        this.ticketFixedValue = 0;
    }
}